import * as colors from "./colors";

// This function returns text color based on the value that is passed in. It producues the same results that '$text-map' from 'variables.scss' generated. - Drew D 1/3/22
export const setTextColor = (theme: string): string => {
  switch (theme) {
    case "primary":
      return colors.colorSecondary;
    case "secondary":
      return colors.colorWhite;
    case "inverted":
      return colors.colorPrimary;
    case "muted":
      return colors.colorSecondary;
    case "info":
      return colors.colorWhite;
    case "success":
      return colors.colorWhite;
    case "danger":
      return colors.colorWhite;
    case "disabled":
      return colors.colorWhite;
    default:
      break;
  }
};
